import React from 'react';
import EditFirmwareState from './editFirmwareState/EditFirmwareState';
import EditForm from './components/EditForm/EditForm';
import { ModalWindows } from './components/ModalWindows';
// import style from './index.module.scss';

const EditFirmwarePage: React.FC = () => {
	return (
		<EditFirmwareState>
			<EditForm />
			<ModalWindows />
		</EditFirmwareState>
	);
};

export default EditFirmwarePage;
